import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavLinksService } from '@services/nav-links/nav-links.service';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { ILoginUsuario } from 'src/app/authentication/models/UserSession.model';
import { TokenService } from 'src/app/authentication/services/token.service';
import { NavigationService } from 'src/app/core/services/components/navigation.service';
import { IAppState } from 'src/app/core/store/root/app.state';
import { cleanCurrentMaquina } from 'src/app/mapa/store/reporte.actions';
import { cleanMaquinas } from 'src/app/maquinas/store/maquina.actions';
import { AppMainComponent } from '../../shared/utilities/app.main.component';

@Component({
	selector: 'app-topbar',
	templateUrl: 'app.topbar.component.html',
	styleUrls: ['app.topbar.component.scss']
})
export class AppTopBarComponent implements OnInit {
	usuario: ILoginUsuario;
	navLinks$: Observable<MenuItem[]>

	constructor(
		public appMain: AppMainComponent,
		public app: AppComponent,
		private storageService: TokenService,
		private navigation: NavigationService,
		private store: Store<IAppState>,
		private navLinksService: NavLinksService
	) {
		this.usuario = this.storageService.getUserLoggedIn();
		this.navLinks$ = this.navLinksService.navLinks
	}
	ngOnInit(): void {
		const userRoles: string[] = this.usuario.rol
		? this.usuario.rol.split(',')
		: [];
		this.navLinksService.filterNavLinksByRole(userRoles); // Subscripcion a navLink
  }
	public logout(): void {
		this.storageService.signOut();
		sessionStorage.clear();
		localStorage.clear();
		this.store.dispatch(cleanCurrentMaquina());
		this.store.dispatch(cleanMaquinas());

		this.navigation.goToAuth();
		
	}
	public misDatos(): void {
		this.navigation.goToMisDatos();
	}
	public perfilEmpresa(): void {
		this.navigation.goToPerfilEmpresa(this.usuario.idEmpresa);
	}
	public goToHome(): void {
    this.navigation.goToHome();
  }
}
